import NewPoll from './NewPoll';
export default NewPoll;
